/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Credentials_DescriptionInputs */

const de_account_credentials_description = /** @type {(inputs: Account_Credentials_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwalten Sie hier Ihre E-Mail-Adresse und Ihr Passwort. Aus Sicherheitsgründen werden Sie dazu aufgefordert, Ihr Passwort einzugeben.`)
};

/** @type {(inputs: Account_Credentials_DescriptionInputs) => LocalizedString} */
const en_account_credentials_description = de_account_credentials_description;

/**

* @param {Account_Credentials_DescriptionInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const account_credentials_description = /** @type {((inputs?: Account_Credentials_DescriptionInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Credentials_DescriptionInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_account_credentials_description(inputs)
	return en_account_credentials_description(inputs)
});